import React from 'react';
import useUserContext from '~/contexts/user';
import { useLocation } from 'react-router-dom';
import { assertDefined } from '~/helpers/data';
import Cookies from 'js-cookie';
const DISMISSED_KEY = 'renewal_dialog_dismissed';
function useCookieKey(key) {
    var _a;
    return React.useReducer((_, value) => {
        Cookies.set(key, value);
        return value;
    }, (_a = Cookies.get(key)) !== null && _a !== void 0 ? _a : '');
}
function useDismissalCookie() {
    var _a, _b;
    const [cookieValue, setCookieValue] = useCookieKey(DISMISSED_KEY);
    const clicked = React.useMemo(() => +Number(cookieValue) > 0, [cookieValue]);
    const { userModel } = useUserContext();
    const isFaculty = ((_a = userModel === null || userModel === void 0 ? void 0 : userModel.accountsModel) === null || _a === void 0 ? void 0 : _a.faculty_status) === 'confirmed_faculty';
    const isAdopter = (_b = userModel === null || userModel === void 0 ? void 0 : userModel.accountsModel) === null || _b === void 0 ? void 0 : _b.using_openstax;
    const { pathname } = useLocation();
    const isFormPage = pathname === '/renewal-form' || pathname === '/adoption';
    const ready = React.useMemo(() => {
        if (isFormPage) {
            return false;
        }
        return !clicked && isFaculty && Boolean(isAdopter);
    }, [clicked, isFaculty, isAdopter, isFormPage]);
    const disable = React.useCallback(() => setCookieValue(Date.now().toString()), [setCookieValue]);
    // Dismiss upon navigation
    React.useEffect(() => {
        window.setTimeout(() => {
            if (!clicked && isFormPage) {
                disable();
            }
        }, 10);
    }, [isFormPage, disable, clicked]);
    return [ready, disable];
}
function AdoptionContentBase({ children, disable }) {
    const { userModel } = useUserContext();
    const { first_name: name } = assertDefined(userModel); // ready ensures this
    const { pathname } = useLocation();
    const href = `${window.location.origin}${pathname}`;
    const renewalFormHref = `/renewal-form?from=popup&returnTo=${encodeURIComponent(href)}`;
    // Return disable so that when dismissed, it is permanently disabled
    React.useEffect(() => disable, [disable]);
    return (React.createElement("div", { className: "microsurvey-content", "data-analytics-view": true, "data-analytics-nudge": "adoption", "data-nudge-placement": "popup" },
        children,
        React.createElement("h1", null,
            "Hi, ",
            name,
            "! Are you still using OpenStax in your course(s)? Please take 1 minute to tell us by filling out",
            ' ',
            React.createElement("a", { href: renewalFormHref, onClick: () => disable(), "data-nudge-action": "interacted" }, "this form"),
            ".")));
}
export default function useAdoptionMicrosurveyContent() {
    const [ready, disable] = useDismissalCookie();
    const AdoptionContent = React.useCallback(({ children }) => (React.createElement(AdoptionContentBase, { disable: disable }, children)), [disable]);
    return [ready, AdoptionContent];
}
